import { all, fork, select, takeLatest, put } from 'redux-saga/effects';
import { sagas } from '@wix/da-shared-react/pkg/redux/shared';
import { sisuFunnelSaga } from '@wix/da-shared-react/pkg/redux/sisuFunnel/saga';
import { appMounted } from '@wix/da-shared-react/pkg/redux/app/actions';
import { getCurrentItem } from '@wix/da-shared-react/pkg/Duperbrowse/redux/selectors';
import { actions as modalActions } from '@wix/da-shared-react/pkg/Modals';

function* appMountedSaga() {
  const deviation: ReturnType<typeof getCurrentItem> = yield select(
    getCurrentItem
  );

  if (deviation && typeof window !== 'undefined') {
    const currentUrl = new URL(window.location.href);
    if (currentUrl.searchParams.get('das')) {
      yield put(modalActions.pushDasModal('manage', deviation));
    }
  }
}

export default function* daDeviationRootSaga() {
  yield all([
    takeLatest(appMounted, appMountedSaga),
    ...sagas.map(fork),
    fork(sisuFunnelSaga),
  ]);
}
